import { useAuth } from '../contexts/AuthContext';
import { canDownloadTicketQr, canSeeCrowdVoltConnect } from './featureAccess';

/**
 * Whether to show this account the CrowdVolt connect prompt.
 *
 * Reads the Firebase identity rather than the backend profile so the answer is
 * available on first paint — waiting on a fetch would flash the banner in and
 * then out again, which is worse than either state on its own.
 *
 * Under admin impersonation this resolves to the IMPERSONATED user's email, so
 * viewing a customer's account shows what that customer sees. That is the same
 * rule `useNewUiAccess` follows, deliberately.
 */
export function useCanSeeCrowdVoltConnect(): boolean {
  const { user } = useAuth();
  return canSeeCrowdVoltConnect(user?.email);
}

/** Whether to show this account the ticket QR code action. Same identity rule as above. */
export function useCanDownloadTicketQr(): boolean {
  const { user } = useAuth();
  return canDownloadTicketQr(user?.email);
}
